import { useTranslation } from 'react-i18next';

import { CERTIFICATE_REVIEW_STATUS } from 'api/documents/documents.model';
import { BasicCard, ErrorCard, SuccessCard } from 'components/BasicCard';

import { ReactComponent as ApprovedIcon } from '../../../../assets/approved.svg';
import { ReactComponent as RejectedIcon } from '../../../../assets/rejected.svg';

type Props = {
  status?: CERTIFICATE_REVIEW_STATUS;
};

const ReviewStatus = ({ status }: Props) => {
  const { t } = useTranslation();

  if (status === CERTIFICATE_REVIEW_STATUS.REJECTED) {
    return (
      <ErrorCard $justify="center">
        <RejectedIcon />
        {t(CERTIFICATE_REVIEW_STATUS.REJECTED)}
      </ErrorCard>
    );
  }

  if (status === CERTIFICATE_REVIEW_STATUS.APPROVED) {
    return (
      <SuccessCard $justify="center">
        <ApprovedIcon />
        {t(CERTIFICATE_REVIEW_STATUS.APPROVED)}
      </SuccessCard>
    );
  }

  return (
    <BasicCard $justify="center">{t(status || CERTIFICATE_REVIEW_STATUS.NOT_PROVIDED)}</BasicCard>
  );
};

export default ReviewStatus;
